import * as AUTH_SERVICES from "api/services/auth/auth.services";
import Breadcrumbs from "components/breadcrumbs";
import React, { useEffect, useState } from "react";
import { RootStateOrAny, useSelector } from "react-redux";
import AppScreen from "screens/teacher/ScreenWithSidebar";

//!STYLES

//IMAGES
import { Button, Drawer, Form, Image, Input, Modal, Skeleton, Tabs, message } from "antd";
import { useParams } from "react-router-dom";

import Wallet from "assets/images/app/header/wallet.svg";
import { StatusCode } from "common/enums";
import AppButton from "components/libs/button";
import { SponsorDrawerPaiement } from "components/paiementSponsor";
import StudentsManagedTable from "components/studentsManaged";
import StudentsParentOrganismHistory from "components/studentsPaymentHistoryParentOrganism";
import ParentOrganismTopUpForStudentsTable from "components/topUpHistoryParentOrganismForStudents";

import TopUpForParentOrganismTable from "components/topUpHistoryForParentOrganism";
import s from "./style.module.css";

const { TabPane } = Tabs;

const OrganismeWallets = () => {

    const auth = useSelector((state: RootStateOrAny) => state.auth);
    const { user } = useSelector((state) => state.auth);
    const params = useParams<"id">();
    const [currentTab, handleTabChange] = useState<string>("1");
    const switchTab = async (tabIndex: string) => {
        handleTabChange(tabIndex);
    }

    const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);
    const [isTablet, setIsTablet] = useState(window.innerWidth > 767 && window.innerWidth <= 1024);

    const handleResize = () => {
        setIsMobile(window.innerWidth <= 767);
        setIsTablet(window.innerWidth > 767 && window.innerWidth <= 1024);
    };

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const [showDispatch, setShowDispatch] = useState<boolean>(false);

    const [budgetDrawerVisibility, setBudgetDrawerVisibility] = useState<boolean>(false);
    const closeBudgetDrawer = async () => {
        setBudgetDrawerVisibility(false);
    }

    const [walletDrawerVisibility, setWalletDrawerVisibility] = useState<boolean>(false);
    const closeWalletDrawer = async () => {
        setWalletDrawerVisibility(false);
    }

    const [page, setPage] = useState<any>("1");
    const [loading, setLoading] = useState<boolean>(true);
    const [topUpHistoryData, setTopUpHistoryData] = useState<any>([]);
    const [parentOrganismTopUpHistoryData, setParentOrganismTopUpHistoryData] = useState<any>([]);
    const [paiementHistoryData, setPaiementHistoryData] = useState<any>([]);
    const [studentsData, setStudentsData] = useState<any>([]);
    const [userData, setUserData] = useState<any>();

    const getTopUpHistory = async () => {
        try {
            const history = await AUTH_SERVICES.getParentOrganismStudentsTopUpHistory(user?._id);
            if (history?.data) {
                setTopUpHistoryData(history?.data?.results);
            } else {
                throw new Error("Error");
            }
        } catch (error) { }
        finally {
            getPaiementHistory();
        }
    }

    const getParentOrganismTopUpHistory = async () => {
        try {
            const history = await AUTH_SERVICES.getParentOrganismTopUpHistory(user?._id);
            if (history?.data) {
                setParentOrganismTopUpHistoryData(history?.data?.data);
            } else {
                throw new Error("Error");
            }
        } catch (error) { }
        finally {
            getPaiementHistory();
        }
    }

    const getPaiementHistory = async () => {
        try {
            const history = await AUTH_SERVICES.getParentOrganismPaiementHistory(user?._id, page);
            if (history?.data) {
                setPaiementHistoryData(history?.data?.results);
            } else {
                throw new Error("Error");
            }
        } catch (error) { }
        finally {
            setLoading(false);
        }
    }

    const getParentStudents = async () => {
        try {
            const students = await AUTH_SERVICES.getParentStudents(user?._id, page);
            if (students?.data) {
                setStudentsData(students?.data?.results);
                setShowDispatch(students?.data?.showButton)
            } else {
                throw new Error("Error");
            }
        } catch (error) { }
        finally {
            setLoading(false);
        }
    }

    const [formInfos] = Form.useForm();
    const [visibleAddModal, setVisibleAddModal] = useState(false);
    const [isMessageLoading, setMessageLoading] = useState<boolean>(false);
    const [idStudent, setIdStudent] = useState<string>('');

    const handleStudentId = (studentId: string) => {
        setIdStudent(studentId);
        setVisibleAddModal(true);
    };

    const handleCancel = () => {
        setVisibleAddModal(false);
    };

    const sendTopUp = async (values: any) => {
        setMessageLoading(true);
        try {
            const response = await AUTH_SERVICES.sendAccountTopUp(user?._id, idStudent, values.montant);
            if (response?.statusCode === StatusCode.CREATED) {
                message.success({
                    content: "Compte rechargé ",
                });
                setMessageLoading(false);
                setVisibleAddModal(false);
            }
            else {
                message.warning({
                    content: "Ooops, Une erreur est survenue",
                });
                setMessageLoading(false);
            }
        } catch (error: any) {
            let content = "";
            for (
                let index = 0;
                index < error?.response?.data?.message?.length;
                index++
            ) {
                content = error?.response?.data?.message[index] + ", " + content;
            }
            message.error({
                content: content,
            });
        } finally {
            getParentStudents();
        }
    }

    const sendEqualTopUp = async () => {
        setMessageLoading(true);
        try {
            const response = await AUTH_SERVICES.sendEqualTopUp(user?._id);
            if (response?.statusCode === StatusCode.CREATED) {
                message.success({
                    content: "Comptes rechargé ",
                });
                setMessageLoading(false);
                setVisibleAddModal(false);
            }
            else {
                message.warning({
                    content: "Ooops, Une erreur est survenue",
                });
                setMessageLoading(false);
            }
        } catch (error: any) {
            let content = "";
            for (
                let index = 0;
                index < error?.response?.data?.message?.length;
                index++
            ) {
                content = error?.response?.data?.message[index] + ", " + content;
            }
            message.error({
                content: content,
            });
        } finally {
            getParentStudents();
        }
    }

    useEffect(() => {
        getTopUpHistory();
        getParentStudents();
        getParentOrganismTopUpHistory();
    }, []);

    return (
        <React.Fragment>
            <Breadcrumbs isDashboard />
            <AppScreen>
                <div style={{
                    display: "flex",
                    flexDirection: "column",
                    margin: "0px",
                    padding: isMobile ? "0 10px" : "0px",
                    position: "relative",
                    top: isMobile ? "0" : "-30px"
                }}>
                    <div style={{
                        display: "flex",
                        flexDirection: isMobile ? "column" : "row",
                        alignItems: isMobile ? "flex-start" : "center",
                        justifyContent: "space-between",
                        height: isMobile ? "auto" : "100px",
                        gap: isMobile ? "15px" : "0"
                    }}>
                        <div style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "flex-start",
                            fontSize: isMobile ? "1em" : "1.7em",
                            fontWeight: "bold",
                            gap: "10px"
                        }}>
                            <Image
                                preview={false}
                                src={Wallet}
                                width={isMobile ? 30 : 50}
                                alt="Wallet"
                            />
                            Solde : {user?.coins} €
                        </div>
                        <div style={{
                            display: "flex",
                            flexDirection: isMobile ? "column" : "row",
                            alignItems: isMobile ? "stretch" : "center",
                            justifyContent: "space-between",
                            gap: isMobile ? "10px" : "0",
                            width: isMobile ? "100%" : "auto"
                        }}>
                            <Button
                                onClick={() => { setWalletDrawerVisibility(true) }}
                                style={{
                                    borderRadius: "10px",
                                    color: "white",
                                    backgroundColor: "#80B1B2",
                                    marginRight: isMobile ? "0" : "20px",
                                    fontSize: isMobile ? "0.85em" : "14px",
                                    width: isMobile ? "100%" : "auto"
                                }}
                            >
                                {"Recharger mon compte"}
                            </Button>
                            <Button
                                onClick={() => { setBudgetDrawerVisibility(true) }}
                                style={{
                                    borderRadius: "10px",
                                    color: "white",
                                    backgroundColor: "#80B1B2",
                                    fontSize: isMobile ? "0.85em" : "14px",
                                    width: isMobile ? "100%" : "auto"
                                }}
                            >
                                {"Gérer l'attribution de mon budget"}
                            </Button>
                        </div>
                    </div>
                    {loading ? <Skeleton active /> : <div style={{
                        background: "#fafafa",
                        borderRadius: "15px",
                        padding: isMobile ? "2%" : "1%",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        width: "100%",
                        marginTop: isMobile ? "10px" : "0"
                    }}>
                        <Tabs activeKey={currentTab} onChange={(key) => switchTab(key)} centered>
                            {<TabPane tab={isMobile ? "Budget utilisé" : "Budget utilisé par élève"} key="1">
                                <StudentsParentOrganismHistory payments={paiementHistoryData} />
                            </TabPane>}
                            {<TabPane tab={isMobile ? "Recharges élèves" : "Historique des recharges pour élèves"} key="2">
                                <ParentOrganismTopUpForStudentsTable payments={topUpHistoryData} />
                            </TabPane>}
                            {<TabPane tab={isMobile ? "Mes recharges" : "Historique de mes recharges"} key="3">
                                <TopUpForParentOrganismTable payments={parentOrganismTopUpHistoryData} />
                            </TabPane>}
                        </Tabs>
                    </div>}
                </div>
                <Drawer
                    placement="right"
                    closable={true}
                    onClose={closeBudgetDrawer}
                    visible={budgetDrawerVisibility}
                    width={isMobile ? "100%" : isTablet ? "85%" : "70%"}
                    headerStyle={{ display: "flex", justifyContent: "space-between" }}
                    bodyStyle={{ background: "#FFF", padding: isMobile ? "10px" : "0px" }}
                    title={<div style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: isMobile ? "1em" : "1.2em"
                    }}>Gérer l'attribution de budget</div>}
                >
                    <div style={{
                        display: "flex",
                        flexDirection: isMobile ? "column" : "row",
                        alignItems: isMobile ? "flex-start" : "center",
                        justifyContent: "space-between",
                        margin: isMobile ? "20px auto" : "40px auto",
                        paddingLeft: isMobile ? "10px" : "20px",
                        paddingRight: isMobile ? "10px" : "20px",
                        gap: isMobile ? "15px" : "0"
                    }}>
                        <div style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "flex-start",
                            fontSize: isMobile ? "1.2em" : "1.7em",
                            fontWeight: "bold",
                            gap: "10px"
                        }}>
                            <Image
                                preview={false}
                                src={Wallet}
                                width={isMobile ? 35 : 50}
                                alt="Wallet"
                            />
                            Solde : {user?.coins} €
                        </div>
                        <div style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: isMobile ? "flex-start" : "center",
                            justifyContent: "space-between",
                            width: isMobile ? "100%" : "auto"
                        }}>
                            {showDispatch && <Button
                                onClick={() => sendEqualTopUp()}
                                style={{
                                    borderRadius: "10px",
                                    color: "white",
                                    backgroundColor: "#80B1B2",
                                    marginRight: isMobile ? "0" : "20px",
                                    fontSize: isMobile ? "0.85em" : "14px",
                                    width: isMobile ? "100%" : "auto"
                                }}
                            >
                                {"Séparer équitablement"}
                            </Button>}
                        </div>
                    </div>
                    <div style={{
                        marginLeft: isMobile ? "10px" : "40px",
                        marginRight: isMobile ? "10px" : "40px"
                    }}>
                        <StudentsManagedTable data={studentsData} onEdit={handleStudentId} />
                    </div>
                </Drawer>
                <Drawer
                    placement="right"
                    closable={true}
                    onClose={closeWalletDrawer}
                    visible={walletDrawerVisibility}
                    width={isMobile ? "100%" : isTablet ? "60%" : "40%"}
                    headerStyle={{ display: "flex", justifyContent: "space-between" }}
                    bodyStyle={{ background: "#FFF", padding: isMobile ? "10px" : "0px" }}
                >
                    <div style={{ alignItems: "flex-start", margin: isMobile ? "20px auto" : "40px auto" }}>
                        <SponsorDrawerPaiement currentUser={user} type="parent/organism" />
                    </div>
                </Drawer>
                <Modal
                    title={<div style={{
                        fontFamily: "CartoonFont",
                        fontSize: isMobile ? "1.3em" : "1.8em",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}>Recharge de solde</div>}
                    visible={visibleAddModal}
                    onCancel={handleCancel}
                    footer={null}
                    closable={true}
                    width={isMobile ? "90%" : "520px"}
                >
                    <p style={{
                        fontFamily: "CartoonFont",
                        fontSize: isMobile ? "1.3em" : "1.8em"
                    }}>Recharger le solde de votre élève</p>
                    <Form
                        validateTrigger={["onFinish"]}
                        name="registerParent"
                        autoComplete="off"
                        form={formInfos}
                        onFinish={sendTopUp}
                    >
                        <Form.Item
                            name="montant"
                            rules={[{ required: true }]}
                            style={{ marginBottom: "20px" }}
                        >
                            <Input
                                type="number"
                                className={s.field}
                                placeholder={"Budget à recharger €"}
                                maxLength={30}
                            />
                        </Form.Item>

                        <div style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center"
                        }}>
                            <Form.Item>
                                <AppButton loading={isMessageLoading} htmlTypeSubmit={true}>Recharger</AppButton>
                            </Form.Item>
                        </div>
                    </Form>
                </Modal>
            </AppScreen>
        </React.Fragment>
    );

}

export default OrganismeWallets;